module.exports = __webpack_public_path__ + "static/1-7fbbc05973839b7dd0d2fd9c6bde1c35.jpeg";